<template>
  <section class="content">
    <div class="row">
      
      <div class="col-md-12">
        <div class="box box-solid">

          <div class="box-header with-border">
            <h3 class="box-title"><b>{{ $route.meta.description }}</b></h3>
          </div>




          <div class="box-body">
            <form style="width:100%" method="POST" @submit.prevent="commit" ref="usuario">
                  <div class='row'>
              <div class="col-sm-12">
                <div :class="{'form-group': true}">
                  <label for="atributos">Empresa</label>
                  <v-select :options="listCidades" v-model="cidadesSelecionadas" name="cidades" ref="inputCidade"> </v-select>

                </div>
              </div>
            </div>
             <div class="row">
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('nome') }">
                  <label for="nome">Nome</label>
                  <input class="form-control" name="nome" type="text" v-model="dados.name" v-validate="'required'">
                  <span v-show="errors.has('nome')" class="help-block">{{ errors.first('nome') }}</span>
                </div>
              </div>
              <div class="col-sm-5">
                <div :class="{'form-group': true, 'has-error':errors.has('email') }">
                  <label for="email">Email</label>
                  <input class="form-control" name="email" type="text" v-model="dados.email" v-validate="'required|email'">
                  <span v-show="errors.has('email')" class="help-block">{{ errors.first('email') }}</span>
                </div>
              </div>
              <div class="col-sm-2">
                <div :class="{'form-group': true, 'has-error':errors.has('nivel') }">
                  <label for="nivel">Nível</label>
                  <select class="form-control" name="nivel" type="text" v-model="dados.nivel">
                    <option value="">--Selecione--</option>
                    <option value="administrador">Administrador</option>
                    <option value="usuario">Usuário</option>
                  </select>
                  <span v-show="errors.has('nivel')" class="help-block">{{ errors.first('nivel') }}</span>
                </div>
              </div>
              
            </div>
            <div class='row'>

              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('usuario') }">
                  <label for="usuario">Usuário</label>
                  <input class="form-control" name="usuario" type="text" v-model="dados.usuario" v-validate="'required'">
                  <span v-show="errors.has('usuario')" class="help-block">{{ errors.first('usuario') }}</span>
                </div>
              </div>



              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('senha') }">
                  <label for="senha">Senha</label>
                  <input class="form-control" name="senha" type="password" v-model="dados.password" v-validate="{required:!atualizacao}" :disabled="atualizacao">
                  <span v-show="errors.has('senha')" class="help-block">{{ errors.first('senha') }}</span>
                </div>
              </div>

              <div class="col-sm-4">
                <div :class="{'form-group': true, 'has-error':errors.has('confirmacaoSenha') }">
                  <label for="confirmacaoSenha">Redigite a Senha</label>
                  <input class="form-control" name="confirmacaoSenha" type="password" v-model="confirmacaoSenha" v-validate="{required:!atualizacao, is:dados.password}" :disabled="atualizacao">
                  <span v-show="errors.has('confirmacaoSenha')" class="help-block">{{ errors.first('confirmacaoSenha') }}</span>
                </div>
              </div>
            </div>



         
            
            <div class="box-footer text-right">
              <router-link tag="a"  to="/usuarios" class="btn btn-default">Voltar</router-link>
              <input class="btn btn-primary" type="submit" value="Salvar">
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
</template>



<script>

  import axios from 'axios'
  import vSelect from 'vue-select'
  import {mask} from 'vue-the-mask'

  export default {
    directives: {mask},
    components: {
      vSelect
    },
    data: () => ({
      dados: {
        id: null,
        name: '',
        usuario: '',
        email: '',
        password: '',
        cpf: '',
        telefone: '',
        nivel: '',
        cidades: []
      },
      confirmacaoSenha: '',
      cidadesSelecionadas: [],
      showSetorArvore: false,
      listCidades: [],
      atualizacao: false,
      
    }),
    mounted() {
      this.getListCidades();
      if (this.$route.params.idUsuario) {
        this.getUserById(this.$route.params.idUsuario);
        this.atualizacao = true;
      }
    },
    methods: {
     getListCidades() {

      this.$store.commit('TOGGLE_LOADING');

      axios.get(`${this.$store.state.serverURI}/api/cidade/dataForSelect`, this.$store.getters.getHeaderAuth).then(response => {

        var stringified = JSON.stringify(response.data);
        stringified = stringified.replace(/nome/g, 'label');
        var data = JSON.parse(stringified);

        this.listCidades = data; 
        this.$store.commit('TOGGLE_LOADING');

      }).catch((error) => { console.log(error) });

    },

    getUserById(id) {
      this.$store.commit('TOGGLE_LOADING');
      axios.get(`${this.$store.state.serverURI}/api/usuario/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
        console.log(response.data);
        this.dados.id = response.data.id;
        this.dados.name = response.data.name;
        this.dados.usuario = response.data.usuario;
        this.dados.email = response.data.email;
        this.dados.nivel = response.data.nivel;
        this.dados.telefone = response.data.telefone;
        this.dados.cpf = response.data.cpf;
        var stringified = JSON.stringify(response.data.cidades);
        stringified = stringified.replace(/nome/g, 'label');
        var cidadesSelecionadas = JSON.parse(stringified);
        this.cidadesSelecionadas = cidadesSelecionadas;

        this.$store.commit('TOGGLE_LOADING');

      }).catch((error) => { console.log(error) });
    },
    commit() {

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('TOGGLE_LOADING');
          if (this.atualizacao) {

            axios.post(`${this.$store.state.serverURI}/api/usuario/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

              this.$store.commit('SHOW_ALERT_SUCCESS');
              this.$router.push('/usuarios');

            }).catch((error) => {
              this.$store.commit('SHOW_ALERT_ERROR');
              console.log(error)
            });

          } else {

            axios.post(`${this.$store.state.serverURI}/api/usuario/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
              this.$store.commit('SHOW_ALERT_SUCCESS');
              this.$router.push('/usuarios');

            }).catch((error) => {
              this.$store.commit('SHOW_ALERT_ERROR');
              console.log(error);
            });

          }
        }
        this.$store.commit('TOGGLE_LOADING');
        return false;
      });

    },

  },
  watch: {
    cidadesSelecionadas: function (value, oldValue) {
      let cidades = [];
      for (let i=0; i<value.length; i++) {
        cidades[i] = value[i].id;
      }
      this.dados.cidades = cidades;
    }
  }
}
</script>

<style scoped>
  form{
    padding: 0;
  }


  /* Customize the label (the container-checks) */
  .container-checks {
    display: inline;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /* Hide the browser's default checkbox */
  .container-checks input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fafafa;
    border: 1px solid #999;
  }
  /* On mouse-over, add a grey background color */
  .container-checks:hover input ~ .checkmark {
    background-color: #F3D999;
    border: none;
  }
  /* When the checkbox is checked, add a blue background */
  .container-checks input:checked ~ .checkmark {
    background-color: #f39c12;
  }

  .container-checks input:disabled ~ .checkmark {
    background-color: #ccc;
    border: 1px solid #ccc;
  }
  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the checkmark when checked */
  .container-checks input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the checkmark/indicator */
  .container-checks .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  } 

  .titulo-permissoes {
    text-align: center;
    font-size: 12px;
    background-color: #f39c12;
    border: 1px solid #e08e0b;
    color: #fafafa;
    padding: 2px;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?ed937df0